module.exports = __webpack_public_path__ + "img/R8806-PX.d3430adf.jpg";